import {trpc} from '@features/utils/trpc';
import {getEffectiveSubscription} from './effectiveSubscription';
import {useSession} from '@features/auth/authClient';

export const useSubscription = () => {
  const {isAuthenticated} = useSession();

  const subscriptionsQuery = trpc.subscription.getSubscriptionInfo.useQuery(
    undefined,
    {
      refetchInterval: 15000,
      refetchOnWindowFocus: true,
      enabled: isAuthenticated,
    },
  );

  function extractData() {
    if (!subscriptionsQuery.data)
      return {maintenanceReadonly: undefined, subscriptions: undefined};

    const {maintenanceReadonly, ...subscriptions} = subscriptionsQuery.data;

    return {maintenanceReadonly, subscriptions};
  }

  const {maintenanceReadonly, subscriptions} = extractData();

  const effectiveSubscription = subscriptions
    ? getEffectiveSubscription(subscriptions)
    : undefined;

  return {
    maintenanceReadonly,
    subscriptions,
    effectiveSubscription: effectiveSubscription,
    isLoading: subscriptionsQuery.isLoading,
    error: subscriptionsQuery.error,
  };
};
